interface PhoneNumbers {
  [key: string]: string
}

const phoneNumbers: PhoneNumbers = {
  US: '(800) 969-1940',
}

export const getRegionPhoneNumber = (region: string): string | undefined => phoneNumbers[region]
